import React from 'react';
import { useQuery } from '@apollo/client';
import { Loader } from '../../../components/Loader';
import Navbar from '../../../components/Navbar';
import EditVerificationForm from '../../../components/VerificationForms/EditVerificationForm';
import { getVerificationById } from '../api';

export const ViewVerificationPage = (props) => {
  const { loading, error, data } = useQuery(getVerificationById, { variables: { verifyId: parseFloat(props.match.params.verifyId) } });

  if (loading) {
    return (
      <div>
        <Navbar />
        <Loader />
      </div>
    );
  }
  if (error) return <div>error</div>;
  if (data) {
    return (
      <div>
        <Navbar />
        <EditVerificationForm data={data} queryData={data} disableFields={true} toTransfer={false} />
      </div>
    );
  }
};
